import React from "react";
import Select from "react-select";
import { Field } from "formik";
import { InputContainer } from "styles/components/AnimatedInput";

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "5px",
    borderColor: "#87cdf1",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: "13px",
    color: "#94a3b8",
    display: state.selectProps.displayFloatingLabel === false ? "block" : "none",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "1rem",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "36px",
    overflow: "inherit",
  }),
  Input: (provided) => ({
    ...provided,
    height: "unset",
  }),
  menu: (provided) => ({
    ...provided,
    position: "absolute",
    textAlign: "left",
    zIndex: "2",
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "13px",
  }),
};

const SelectDropDown = (props) => {
  return (
    <Field name={props?.name}>
      {({ field, form, meta }) => {
        const valToMatch = props?.selectedValue !== undefined && props?.selectedValue !== null && props?.selectedValue !== "" ? props?.selectedValue : field.value;
        let valueData = props?.data?.filter(
          (option) =>
            option.value === valToMatch ||
            (valToMatch && String(option.value).toLowerCase() === String(valToMatch).toLowerCase()) ||
            option.label === valToMatch
        );
        return (
          <InputContainer className={props.className}>
            <div className="input-container">
              <Select
                className={`react-select-container ${meta.touched && meta.error ? "error" : ""
                  }`}
                name={props?.name}
                value={valueData}

                options={props?.data}
                isDisabled={props?.disabled}
                classNamePrefix="react-select"
                placeholder={props?.placeholder}
                displayFloatingLabel={props?.displayFloatingLabel}
                isSearchable={props?.searchable}
                styles={customStyles}
                maxMenuHeight={150}
                onInputChange={inputValue =>
                  (inputValue.length <= 18 ? inputValue : '')
                }
                onChange={(data) => {
                  props?.onChangeHandler && props?.onChangeHandler(data.value, data);
                  form.setFieldValue(props?.name, data.value);
                }}
              />

              {props?.displayFloatingLabel !== false && (
                <label className={field.value && 'filled'} htmlFor={props?.name}>
                  {props?.placeholder}
                </label>
              )}
              {meta.touched && meta.error && (
                <p name={props?.name + "Error"} className="error-message">
                  {meta.error}
                </p>
              )}
            </div>
          </InputContainer>
        );
      }}
    </Field>
  );
};
export default SelectDropDown;